// client, index, and server use this exported BASE_NAME for defining the module.
// When creating a new module, copy the example folder and update the BASE_NAME as desired
export const BASE_NAME = 'error';
